import React, { useEffect, useState } from "react";
import { getPosterForMovie } from "../../firebase/moviedb";
import { MovieDBType } from "../../types/Movie";
type MovieMatchProps = {
  movieMatch: MovieDBType;
  onMovieSelected: (movieMatch: MovieDBType) => void;
};

const MovieMatch: React.FC<MovieMatchProps> = ({
  movieMatch,
  onMovieSelected,
}) => {
  const [posterUrl, setPosterUrl] = useState<string>();
  useEffect(() => {
    if (movieMatch && movieMatch.poster_path) {
      getPosterForMovie(movieMatch).then((poster) => setPosterUrl(poster));
    }
  }, [movieMatch]);

  return (
    <div className="movie-match-wrapper">
      <div className={"movie-header"}>
        <div
          tabIndex={0}
          onClick={() => onMovieSelected(movieMatch)}
          className={"movie-title"}
        >
          {movieMatch.title} ({movieMatch.release_date.slice(0, 4)})
        </div>
        <div className={"movie-description"}>{movieMatch.overview}</div>
      </div>
      <div className={"movie-poster"}>
        {posterUrl ? (
          <img alt="movie-poster" className={"movie-image"} src={posterUrl} />
        ) : (
          <div className={"loading"}>...</div>
        )}
      </div>
    </div>
  );
};
export default MovieMatch;
